function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M76.967,235.173c-5.456,2.914-11.325,4.303-17.105,4.303c-12.965,0-25.505-6.957-32.048-19.187 c-9.46-17.685-2.796-39.696,14.883-49.154c31.661-16.943,77.224-97.418,99.469-149.149c7.923-18.427,29.282-26.953,47.706-19.018 c18.421,7.923,26.938,29.282,19.018,47.706C198.269,75.381,141.983,200.382,76.967,235.173z M340.848,313.248 c-43.663-35.654-108.575-101.589-116.158-136.562c-4.244-19.594-23.555-32.057-43.181-27.801 c-19.6,4.25-32.042,23.587-27.795,43.193c15.622,72.063,120.391,160.472,141.231,177.465c6.738,5.491,14.854,8.169,22.922,8.169 c10.533,0,20.978-4.563,28.153-13.364C358.698,348.807,356.381,325.933,340.848,313.248z M337.171,291.662 c2.075,1.69,3.919,3.552,5.639,5.496c-0.271-4.888-1.513-9.787-3.871-14.428c-6.709-13.217-20.416-20.546-34.324-19.801 C315.426,273.138,326.473,282.926,337.171,291.662z M180.793,273.19c-25.064-2.358-49.911-6.117-69.907-10.22 c-19.653-4.072-38.851,8.582-42.903,28.225c-4.055,19.646,8.585,38.857,28.23,42.906c16.296,3.363,74.074,14.375,131.343,14.375 c8.719,0,17.432-0.261,25.984-0.84C232.77,329.283,204.947,302.768,180.793,273.19z M289.519,221.063 c20.546-53.457,30.996-111.341,33.697-127.755c3.269-19.792-10.131-38.477-29.926-41.739c-19.79-3.263-38.491,10.128-41.736,29.926 c-3.34,20.135-10.51,60.914-17.307,85.154c8.789,45.66,28.076,53.226,45.164,78.37 C283.022,237.247,286.392,229.209,289.519,221.063z"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var _ref17 = /*#__PURE__*/React.createElement("g", null);

var SvgBacteria = function SvgBacteria(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    width: "377.711px",
    height: "377.711px",
    viewBox: "0 0 377.711 377.711",
    style: {
      enableBackground: "new 0 0 377.711 377.711"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBacteria, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/bacteria.33b1df34.svg";
export { ForwardRef as ReactComponent };